import QueryPersonalGroup from './queryPersonalGroup.gql';
import SavePersonalGroup from './savePersonalGroup.gql';
import DeletePersonalGroup from './deletePersonalGroup.gql';
import {mutationHdl, queryHdl} from '../graphqlHdr';

export default {
  queryList: (vueSelf, variables) => queryHdl.call(vueSelf, QueryPersonalGroup, variables),

  savePersonalGroup: (vueSelf, variables) => mutationHdl.call(vueSelf, SavePersonalGroup, variables),

  deletePersonalGroup: (vueSelf, variables) => mutationHdl.call(vueSelf, DeletePersonalGroup, variables),
}
